import PolicyPage from "../components/PolicyPage";
export default function Policies() { return <PolicyPage namespace="policies" />; }
